import type { IconName } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { StyledControlIcon, StyledControlLink } from './styles';

type Direction = 'left' | 'right' | 'left-end' | 'right-end';

type PaginationControlProps = {
  direction: Direction;
  onClick: () => void;
  disabled: boolean;
};

const getIconName = (direction: Direction): IconName => {
  switch (direction) {
    case 'left':
      return 'chev-left-n';
    case 'right':
      return 'chev-right-n';
    case 'left-end':
      return 'chev-left-end';
    case 'right-end':
      return 'chev-right-end';
  }
};

export const PaginationControl = ({ direction, onClick, disabled }: PaginationControlProps) => {
  const handlePageChange = () => {
    if (disabled) {
      return;
    }
    onClick();
  };

  return (
    <StyledControlLink onClick={handlePageChange}>
      <StyledControlIcon
        data-automation-pagination-control-disabled={direction}
        data-automation-pagination-control="control-left-end"
        iconName={getIconName(direction)}
        disabled={disabled}
        iconColor={disabled ? colorsPalettes.carbon[100] : colorsPalettes.carbon[200]}
        hoverIconColor={disabled ? colorsPalettes.carbon[100] : colorsPalettes.carbon[500]}
      />
    </StyledControlLink>
  );
};
